import { useParams } from 'react-router-dom';

import usePermissions from 'api/usePermissions';
import { EAnalyticsState } from 'constants/navigation';
import { useIsSlaPageEnabled } from 'hooks/useIsSlaPageEnabled';

import {
  getAccessibleAnalyticsTabs,
  getDefaultAnalyticsTab,
  isSlaPageVisibleForUserRole
} from './analyticsTabsAccess';

interface IAnalyticsTabsAccess {
  accessibleTabs: EAnalyticsState[];
  defaultTab: EAnalyticsState;
}

export const useAnalyticsTabsAccess = (): IAnalyticsTabsAccess => {
  const { publisherId } = useParams();
  const { getPermissions, isSuperAdminByProject } = usePermissions();
  const isSlaPageEnabled = useIsSlaPageEnabled();
  const permissions = getPermissions();
  const projectId = publisherId || '';

  const isSlaPageVisible = isSlaPageVisibleForUserRole({
    isSlaFeatureFlagEnabled: isSlaPageEnabled,
    isSuperAdmin: isSuperAdminByProject(projectId)
  });

  return {
    accessibleTabs: getAccessibleAnalyticsTabs(
      permissions,
      projectId,
      isSlaPageVisible
    ),
    defaultTab: getDefaultAnalyticsTab(permissions, projectId, isSlaPageVisible)
  };
};
